// Service slugs map to translation keys
export const SERVICE_KEYS = ["sanitaer", "heizung", "sanierung", "umbau"];

export const SERVICE_META = {
  sanitaer: {
    slug: "sanitaer",
    image: "https://images.pexels.com/photos/7045908/pexels-photo-7045908.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    icon: "Droplets",
    color: "#4D6BFF",
  },
  heizung: {
    slug: "heizung",
    image: "https://images.unsplash.com/photo-1618840626133-54463084a141?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBoZWF0aW5nJTIwYm9pbGVyJTIwc3lzdGVtfGVufDB8fHx8MTc4MTUzMzg4N3ww&ixlib=rb-4.1.0&q=85",
    icon: "Flame",
    color: "#E11D48",
  },
  sanierung: {
    slug: "sanierung",
    image: "/references/project-1.jpeg",
    icon: "Hammer",
    color: "#0F766E",
  },
  umbau: {
    slug: "umbau",
    image: "https://images.unsplash.com/photo-1542621334-a254cf47733d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxhcmNoaXRlY3R1cmFsJTIwYmx1ZXByaW50JTIwZW5naW5lZXJpbmd8ZW58MHx8fHwxNzgxNTMzODg3fDA&ixlib=rb-4.1.0&q=85",
    icon: "Building2",
    color: "#7C3AED",
  },
};

export const REFERENCES = [
  {
    id: 1,
    title: { de: "Fertiggestelltes Bad mit Kupferarmaturen", en: "Finished bathroom with copper fixtures", fr: "Salle de bain terminée avec robinetterie cuivre" },
    category: "sanierung",
    location: "Basel",
    year: 2025,
    image: "/references/project-1.jpeg",
  },
  {
    id: 2,
    title: { de: "Warmwasser- & Heizungsinstallation", en: "Hot water & heating installation", fr: "Installation eau chaude & chauffage" },
    category: "heizung",
    location: "Allschwil",
    year: 2025,
    image: "/references/project-2.jpeg",
  },
  {
    id: 3,
    title: { de: "Vorwand-Installation WC", en: "Pre-wall WC installation", fr: "Installation pré-mur WC" },
    category: "sanitaer",
    location: "Allschwil",
    year: 2025,
    image: "/references/project-3.jpeg",
  },
  {
    id: 4,
    title: { de: "Luft-Wärmepumpen-Aussengerät", en: "Air-to-water heat pump exterior unit", fr: "Unité extérieure pompe à chaleur air-eau" },
    category: "heizung",
    location: "Binningen",
    year: 2025,
    image: "/references/project-4.jpeg",
  },
  {
    id: 5,
    title: { de: "Badezimmer-Rohbau, Wannenmontage", en: "Bathroom rough-in with tub", fr: "Gros œuvre salle de bain avec baignoire" },
    category: "sanitaer",
    location: "Basel",
    year: 2025,
    image: "/references/project-5.jpeg",
  },
  {
    id: 6,
    title: { de: "Sanitär-Vorwand & Wanneninstallation", en: "Plumbing pre-wall & tub install", fr: "Pré-mur sanitaire & baignoire" },
    category: "sanitaer",
    location: "Riehen",
    year: 2025,
    image: "/references/project-6.jpeg",
  },
  {
    id: 7,
    title: { de: "Nasszelle Rohbau", en: "Wet-room rough-in", fr: "Local humide - gros œuvre" },
    category: "sanitaer",
    location: "Pratteln",
    year: 2024,
    image: "/references/project-7.jpeg",
  },
  {
    id: 8,
    title: { de: "Sanitär-Installation Wohnung", en: "Apartment plumbing install", fr: "Installation sanitaire appartement" },
    category: "sanitaer",
    location: "Basel",
    year: 2024,
    image: "/references/project-8.jpeg",
  },
  {
    id: 9,
    title: { de: "Neubau WC-Vorwandelement", en: "New WC pre-wall element", fr: "Nouvel élément pré-mur WC" },
    category: "sanitaer",
    location: "Allschwil",
    year: 2024,
    image: "/references/project-9.jpeg",
  },
  {
    id: 10,
    title: { de: "Rohinstallation Sanitär", en: "Plumbing rough-in", fr: "Installation sanitaire brute" },
    category: "sanitaer",
    location: "Basel",
    year: 2024,
    image: "/references/project-10.jpeg",
  },
  {
    id: 11,
    title: { de: "Sanitärleitungen im Neubau", en: "Plumbing lines in new build", fr: "Conduites sanitaires nouveau bâtiment" },
    category: "sanitaer",
    location: "Reinach",
    year: 2024,
    image: "/references/project-11.jpeg",
  },
  {
    id: 12,
    title: { de: "Fertiges Bad hell & modern", en: "Finished bathroom bright & modern", fr: "Salle de bain lumineuse & moderne" },
    category: "sanierung",
    location: "Basel",
    year: 2025,
    image: "/references/project-12.jpeg",
  },
  {
    id: 13,
    title: { de: "Badumbau mit Doppel-Waschtisch", en: "Bathroom remodel with double vanity", fr: "Rénovation avec double vasque" },
    category: "umbau",
    location: "Muttenz",
    year: 2024,
    image: "/references/project-13.jpeg",
  },
  {
    id: 14,
    title: { de: "Komplettsanierung Bad im Bau", en: "Complete bathroom renovation in progress", fr: "Rénovation complète en cours" },
    category: "sanierung",
    location: "Basel",
    year: 2024,
    image: "/references/project-14.jpeg",
  },
  {
    id: 15,
    title: { de: "Wandsanierung mit Neuverlegung", en: "Wall renovation with new piping", fr: "Rénovation murale nouvelle tuyauterie" },
    category: "sanierung",
    location: "Allschwil",
    year: 2024,
    image: "/references/project-15.jpeg",
  },
  {
    id: 16,
    title: { de: "Geberit GIS Vorwand-Sanierung", en: "Geberit GIS pre-wall renovation", fr: "Rénovation pré-mur Geberit GIS" },
    category: "sanierung",
    location: "Basel",
    year: 2024,
    image: "/references/project-16.jpeg",
  },
  {
    id: 17,
    title: { de: "Rückbau & Umbau Bad", en: "Bathroom demolition & remodel", fr: "Démolition & transformation salle de bain" },
    category: "umbau",
    location: "Binningen",
    year: 2024,
    image: "/references/project-17.jpeg",
  },
  {
    id: 18,
    title: { de: "Umbau Bad im Altbau", en: "Old building bathroom remodel", fr: "Transformation salle de bain ancienne" },
    category: "umbau",
    location: "Basel",
    year: 2023,
    image: "/references/project-18.jpeg",
  },
];

export const TESTIMONIALS = [
  {
    id: 1,
    name: "Daniela M.",
    role: { de: "Hauseigentümerin, Basel", en: "Homeowner, Basel", fr: "Propriétaire, Bâle" },
    rating: 5,
    text: {
      de: "Pünktlich, freundlich und absolut professionell. Unser Bad wurde in zwei Wochen komplett saniert – sauber und ohne Stress.",
      en: "Punctual, friendly, and absolutely professional. Our bathroom was completely renovated in two weeks – clean and stress-free.",
      fr: "Ponctuels, sympathiques et absolument professionnels. Notre salle de bain a été entièrement rénovée en deux semaines.",
    },
  },
  {
    id: 2,
    name: "Thomas K.",
    role: { de: "Immobilienverwaltung", en: "Property management", fr: "Gestion immobilière" },
    rating: 5,
    text: {
      de: "Auf SHK Haustechnik verlassen wir uns seit Jahren. Pikett funktioniert wirklich – auch am Sonntagabend.",
      en: "We have relied on SHK Haustechnik for years. The emergency service really works – even on a Sunday evening.",
      fr: "Nous comptons sur SHK Haustechnik depuis des années. Le service d'urgence fonctionne vraiment – même le dimanche.",
    },
  },
  {
    id: 3,
    name: "Sandra B.",
    role: { de: "Geschäftsführerin", en: "Managing director", fr: "Directrice" },
    rating: 5,
    text: {
      de: "Faire Offerte, klare Kommunikation, top Resultat. Wir empfehlen das Team uneingeschränkt weiter.",
      en: "Fair quote, clear communication, top result. We recommend the team without reservation.",
      fr: "Devis juste, communication claire, résultat de premier ordre. Nous recommandons sans réserve.",
    },
  },
];

export const CONTACT_INFO = {
  name: "Elvis Pashaj",
  company: "SHK Haustechnik GmbH",
  email: "info@shk-haustechnik.ch",
  phone: "+41 78 256 45 99",
  phoneClean: "+41782564599",
  whatsappClean: "41782564599",
  street: "Weiherweg 14",
  city: "4123 Allschwil",
  mapsEmbed: "https://www.google.com/maps?q=Weiherweg+14,+4123+Allschwil,+Switzerland&output=embed",
  logo: "https://customer-assets.emergentagent.com/job_a1efe1bb-725e-4604-9865-02b05fcb8255/artifacts/58ps4b9l_Bildschirmfoto%202026-06-15%20um%2016.28.05.png",
};
